import {Button,Checkbox,Form,Input,message,Modal,Select} from "antd";
import { useEffect, useState } from "react";
import "./auditFormView.css";
import secureLocalStorage from "react-secure-storage";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import CustomLoader from "../../common/customLoader";
import { editAuditFormThunk, updateAuditFormThunk } from "../../../store/thunks/auditFormsThunk";
import { useDispatch } from "react-redux";

const AuditFormEdit = ({
  children = null,
  key_elem = "1",
  nameLink = "",
  editRecord,
  routeState,
  processes,
  onSuccess
}) => {  
  console.log("onSuccess exists:", typeof onSuccess);
  const dispatch = useDispatch();
  const id = editRecord?.key;

  const slsRole = secureLocalStorage.getItem("role");
  const slsToken = secureLocalStorage.getItem("accessToken");
  const slsLIUId = secureLocalStorage.getItem("lIUId");

  const [form] = Form.useForm();
  const { confirm } = Modal;
  const { Option } = Select;

  const [showLoader, setShowLoader] = useState(true);
  const [isWeightageForm, setIsWeightageForm] = useState(false);
  const [parameters, setParameters] = useState([]);  
  const [errors, setErrors] = useState([]);
  const [auditFormSelectedProcess, setAuditFormSelectedProcess] = useState();
  const [activeAudits, setActiveAudits] = useState();
  const [error, setError] = useState("");
  
  /*begin::getAuditFormDetail will fetch audit form's detail*/
  const getAuditFormDetail = async () => {
    await dispatch(editAuditFormThunk({id})).unwrap()
      .then((response) => {
        setAuditFormSelectedProcess(response.process);
        setActiveAudits(response.activeAudits);

        setIsWeightageForm(response?.hasWeightage === "TRUE" ? true : false);

        form.setFieldsValue({
          status: response?.status,
        });

        // Set Parameters
        const parsedQMF = JSON.parse(response.formContent);
        const questions =
          parsedQMF?.elements?.questions &&
          parsedQMF?.elements?.questions.filter(
            (questions) => questions.input_type === "radio-group"
          );
        setParameters(questions);

        setShowLoader(false);
      })
      .catch((error) => {
        error?.data?.message && message.error(error?.data?.message);
      });
  };
  /*end::getAuditFormDetail will fetch audit form's detail*/

  const handleCheckboxChange = (e) => {
    setIsWeightageForm(e.target.checked); // Update state when checkbox is toggled
  };

  const handleAddParameter = () => {
    const qualityParametersLength = document.getElementsByClassName(
      "drgdrp-form-innerContainer"
    ).length;

    const newParameter = {
      serial_no: String(qualityParametersLength + 1),
      type: "radio-group",
      display_text: "",
      meta: { critical: false, required: false },
    };

    if (isWeightageForm) {
      newParameter.meta.weightage = null;
    }

    setParameters([...parameters, newParameter]);
    setError(""); // Clear the error when adding a parameter

    // Update form values to include the new parameter
    const weightage = isWeightageForm && {
      [`weightage_${parameters.length}`]: newParameter.meta.weightage || null,
    };
    const updatedValues = {
      ...form.getFieldsValue(),
      [`serial_no_${parameters.length}`]: String(newParameter.serial_no),
      [`type_${parameters.length}`]: newParameter.type,
      [`displayText_${parameters.length}`]: newParameter.display_text,
      ...weightage,
      [`critical_${parameters.length}`]: newParameter?.meta.critical || false,
      [`required_${parameters.length}`]: newParameter?.meta.required || false,
    };
    form.setFieldsValue(updatedValues);
  };

  const handleRemoveParameter = (index) => {
    const updatedParameters = parameters.filter((_, i) => i !== index);

    // Reindex the remaining parameters
    const reindexedParameters = updatedParameters.map((param, i) => ({
      ...param,
      serial_no: String(i + 1), // Update the serial_no based on the new index
    }));

    setParameters(reindexedParameters);
    // Update form values to reflect the removal
    const updatedValues = {};

    reindexedParameters.forEach((param, i) => {
      updatedValues[`serial_no_${i}`] = String(param.serial_no);
      updatedValues[`type_${i}`] = param.input_type;
      updatedValues[`displayText_${i}`] = param.display_text;

      // Update weightage values only if isWeightageForm is true
      if (isWeightageForm) {
        updatedValues[`weightage_${i}`] = param.meta.weightage;
      }

      updatedValues[`critical_${i}`] = param.meta.critical || false;
      updatedValues[`required_${i}`] = param.meta.required || false;
    });
    form.setFieldsValue(updatedValues);
  };

  const onFinish = (values) => {
    if (parameters.length === 0) {
      setError("Please add at least one parameter.");
      return;
    }
    // Show a confirmation modal
    confirm({
      title:
        "Confirm!",
      content: (
    <>
      <p>
        Please review your selected or entered information carefully before
        submitting the form, as changes may not be possible once it's submitted.
      </p>
      <p>Are you sure you want to submit the form?</p>
    </>
  ),
      okText: "Yes",
      cancelText: "No",
      className: "revokeConfirmModal",      
      okButtonProps: {
        className: "defaultBtn",
      },
      cancelButtonProps: {
        className: "defaultBtn defaultGreyBtn",
      },
      async onOk() {
        try {
          setError("");        
          let selectedProcess = {};
          if (processes && processes?.length > 0) {
            selectedProcess =
              processes &&
              processes.find((process) => {
                return process.value === auditFormSelectedProcess;
              });
          }
          values["isWeightageForm"] = isWeightageForm;
          const payload = {
            slsRole,
            formName: selectedProcess && selectedProcess?.label,
            process: selectedProcess && selectedProcess?.value,
            hasWeightage: isWeightageForm === true ? "TRUE" : "FALSE",
            formContent: values,
            status: values?.status,
            historySource: "backend",
            historyAction: "update",
            historyUserID: slsLIUId,
            updatedAt: new Date(
              new Date().getTime() - new Date().getTimezoneOffset() * 60000
            )
              .toISOString()
              .slice(0, 19)
              .replace("T", " "),
          };

          await dispatch(updateAuditFormThunk({ id, ...payload })).unwrap()
          message.success("AuditForm updated successfully");
          form.resetFields();
          setParameters([]);

          // 🔑 THIS IS THE KEY
          onSuccess?.();

        } catch (error) {
          const errorMessage =
            error?.data?.message || "An error occurred while updating the auditForm";
          setErrors([errorMessage]);
          message.error(errorMessage);
        }
      },
      onCancel() {
        // User canceled
        console.log("Form submission canceled");
      },
    });
  };


  useEffect(() => {
    getAuditFormDetail();
  }, [routeState?.route]);

  // Initial parameter values
  const initialParameters = [
    {
      id: "1",
      type: "radio-group",
      name: "Parameter 1",
      display_text: "Parameter 1",
      displayText: "Parameter 1",
      meta: { weightage: 10, critical: false, required: false },
    },
    {
      id: "2",
      type: "radio-group",
      name: "Parameter 2",
      display_text: "Parameter 2",
      displayText: "Parameter 2",
      meta: { weightage: 20, critical: false, required: true },
    },
    {
      id: "3",
      type: "radio-group",
      name: "Parameter 3",
      display_text: "Parameter 3",
      displayText: "Parameter 3",
      meta: { weightage: 30, critical: false, required: true },
    },
    {
      id: "4",
      type: "radio-group",
      name: "Parameter 4",
      display_text: "Parameter 4",
      displayText: "Parameter 44",
      meta: { weightage: 40, critical: true, required: true },
    },
  ];

  // Function to handle drag end event and reorder parameters
  const onDragEnd = (result) => {
    const { source, destination } = result;

    // Exit if dropped outside the list
    if (!destination) return;

    // Reorder the parameters array based on drag result
    const reorderedParameters = Array.from(parameters);
    const [removed] = reorderedParameters.splice(source.index, 1);
    reorderedParameters.splice(destination.index, 0, removed);

    // Update the state with the new order
    setParameters(reorderedParameters);

    // Update form values with the new parameter order
    updateFormValues(reorderedParameters);
  };

  // Function to update form values after parameters are reordered
  const updateFormValues = (params) => {
    const updatedValues = {};
    params.forEach((param, index) => {
      updatedValues[`type_${index}`] =
        param.input_type || param.type || "radio-group";
      updatedValues[`displayText_${index}`] = param.display_text;

      // Update weightage values only if isWeightageForm is true
      if (isWeightageForm) {
        updatedValues[`weightage_${index}`] = param.meta.weightage;
      }

      updatedValues[`critical_${index}`] = param.meta.critical || false;
      updatedValues[`required_${index}`] = param.meta.required || false;
    });
    form.setFieldsValue(updatedValues); // Sync form values with the new order
  };

  // Effect hook to set initial form values when the component mounts
  useEffect(() => {
    updateFormValues(parameters);
  }, [parameters]);

  return (
    <div>
      <CustomLoader showLoader={showLoader} />
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="parameters">
            {(provided) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                className="drgdrp-outerContainer"
              >
                <Form
                  form={form}
                  layout="vertical"
                  onFinish={onFinish}
                  className="drgdrp-form-outerContainer editAuditForm"
                >
                  <Form.Item
                    name="isWeightageForm"
                    initialValue={isWeightageForm}
                    className="pb-16"
                  >
                    <Checkbox
                      checked={isWeightageForm}
                      onChange={handleCheckboxChange}
                      className="weightTage"
                    >
                      Is this a Weightage Form?
                    </Checkbox>
                  </Form.Item>
                  <div className="d-flex justify-content-between plr-16">
                    <label className="qualityParameters">Quality Parameters</label>
                    
                  </div>
                  <div className="parameters-container-wrap">
                    <Button
                      type="dashed"
                      onClick={handleAddParameter}
                     // icon={<PlusOutlined />}
                      className="addParametersBtn"
                    >
                      + Add Parameter
                    </Button>
                  {parameters.map((param, index) => (
                    <Draggable
                      key={String(param.serial_no)}
                      draggableId={String(param.serial_no)}
                      index={index}
                    >
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          className="drgdrp-form-innerContainer"
                          style={{
                            ...provided.draggableProps.style,
                          }}
                        >
                          <Form.Item
                            name={`type_${index}`}
                            initialValue={param.type}
                            hidden
                          >
                            <span></span>
                          </Form.Item>

                          {/* Title */}
                          <Form.Item
                            name={`displayText_${index}`} // This ensures that form field names are dynamically set
                            label=""
                            rules={[
                              {
                                required: true,
                                message: "Title is required",
                              },
                            ]}
                          >
                            <textarea
                              className={`text__area`}
                              value={param.displayText}
                              placeholder="Enter a title"
                              onChange={(e) => {
                                // Update parameter value when input changes
                                const newParameters = parameters.map((p) => {
                                  return p.serial_no === param.serial_no
                                    ? { ...p, display_text: e.target.value }
                                    : p;
                                });

                                setParameters(newParameters);
                                updateFormValues(newParameters); // Synchronize form values
                              }}
                              rows={2}
                              width={"full"}
                            ></textarea>
                          </Form.Item>

                          {/* Critical */}
                          <Form.Item
                            name={`critical_${index}`}
                            initialValue={false}
                            label=""
                          >
                            <Checkbox
                              checked={param?.meta?.critical}
                              onChange={(e) => {
                                const isChecked = e.target.checked; // Get true/false based on checkbox state

                                // Update critical when input changes
                                const newParameters = parameters.map((p) =>
                                  p.serial_no === param.serial_no
                                    ? {
                                        ...p,
                                        meta: {
                                          ...p.meta,
                                          critical: isChecked,
                                        },
                                      }
                                    : p
                                );
                                setParameters(newParameters);
                                updateFormValues(newParameters); // Synchronize form values
                              }}
                            >
                              Critical
                            </Checkbox>
                          </Form.Item>

                          {/* Mandatory */}
                          <Form.Item name={`required_${index}`} label="">
                            <Checkbox
                              checked={param?.meta?.required}
                              onChange={(e) => {
                                const isChecked = e.target.checked; // Get true/false based on checkbox state

                                // Update required when input changes
                                const newParameters = parameters.map((p) =>
                                  p.serial_no === param.serial_no
                                    ? {
                                        ...p,
                                        meta: {
                                          ...p.meta,
                                          required: isChecked,
                                        },
                                      }
                                    : p
                                );
                                setParameters(newParameters);
                                updateFormValues(newParameters); // Synchronize form values
                              }}
                            >
                              Mandatory
                            </Checkbox>
                          </Form.Item>

                          {isWeightageForm && (
                            <Form.Item
                              name={`weightage_${index}`}
                              label=""
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter weightage",
                                },
                              ]}
                            >
                              <Input
                                placeholder="Enter weightage"
                                type="number"
                                value={param.meta.weightage}
                                onChange={(e) => {
                                  // Update weightage when input changes
                                  const newParameters = parameters.map((p) =>
                                    p.serial_no === param.serial_no
                                      ? {
                                          ...p,
                                          meta: {
                                            ...p.meta,
                                            weightage: parseInt(e.target.value),
                                          },
                                        }
                                      : p
                                  );
                                  setParameters(newParameters);
                                  updateFormValues(newParameters); // Synchronize form values
                                }}
                              />
                            </Form.Item>
                          )}
                          <Button
                            onClick={() => handleRemoveParameter(index)}
                            className="deleteBtn m-0"
                          >
                            <i className="fa fa-trash" aria-hidden="true"></i>
                          </Button>
                        </div>
                      )}
                    </Draggable>
                  ))}
                   {provided.placeholder}
                  <Form.Item label="Status" name="status" className="status">
                    <Select>
                      <Option value="ACTIVE">ACTIVE</Option>
                      <Option value="INACTIVE">IN-ACTIVE</Option>
                    </Select>
                  </Form.Item>
                  </div>
                 
                  <div className="modalFooter">
                    <div className="modalBtns">
                      <Button
                    type="primary"
                    htmlType="submit"
                   className="defaultBtn m-0"
                  >
                    Update
                  </Button>
                    </div>
                    
                  </div>
                  
                </Form>
              </div>
            )}
          </Droppable>
        </DragDropContext>
    </div>
  );
};
export default AuditFormEdit;
